import { ATVCategories, ATVDriveTypes, ATVStarters } from "./ATV";
import { MotorcycleCategory, MotorcycleDriveTypes } from "./Motorcycle";

export interface LocationInterface {
  locationName: string;
  address: string;
  city: string;
  state: string;
  stateShortname: string;
  zipcode: string;
  geometry: {
    latitude: number;
    longitude: number;
  };
}

export enum OwnershipTypes {
  Owned = "owned",
  Financed = "financed",
  Leased = "leased",
}

export enum TitlePossessions {
  Lost = "lost",
  Held = "held",
  External = "external",
}

interface AvailableTimingSlot {
  start: Date;
  end: Date;
}

interface AvailableTimings {
  Monday?: AvailableTimingSlot[];
  Tuesday?: AvailableTimingSlot[];
  Wednesday?: AvailableTimingSlot[];
  Thursday?: AvailableTimingSlot[];
  Friday?: AvailableTimingSlot[];
  Saturday?: AvailableTimingSlot[];
  Sunday?: AvailableTimingSlot[];
}

export enum SellerListingDisplayTypes {
  Public = "public",
  Private = "private",
}

export interface SellerListingTitleAttachmentFile {
  key: string;
  mimetype: string;
  filename: string;
  size: number;
}

export interface SellerListingTitleAttachments {
  completedDate: Date;
  front: SellerListingTitleAttachmentFile;
  back: SellerListingTitleAttachmentFile;
}

export enum SellerListingStatuses {
  Live = "live",
  Pending = "pending",
  Sold = "sold",
  Removed = "removed",
  Purchased = "purchased",
  Deactivated = "deactivated",
  Expired = "expired",
  ExpiredGrace = "expiredGrace",
}

export enum ListingCategoryTypes {
  Auto = "Auto",
  ATVOHV = "ATV/OHV",
  Motorcycle = "Motorcycle",
  RV = "RV",
  Boat = "Boat",
}

export enum UploadedVideoTypes {
  YouTube = "youtube",
  Custom = "custom",
}
export interface ISellerListingUploadVideo {
  type: UploadedVideoTypes;
  url: string;
  createdAt: Date;
  updatedAt: Date;
  meta?: any;
  order?: number;
}

export interface SellerListing {
  listingNo: string;
  _id: string;
  slug: string;
  status: SellerListingStatuses;
  dateStatusLastChanged: Date;
  userId: string;
  isVintageVehicle: boolean;
  CarMake: string;
  CarModel: string;
  RegistrationYear: number;
  BodyStyle: string;
  Transmission: string;
  Trim: string;
  ExteriorColor: string;
  InteriorColor: string;
  DriveType: string;
  Doors: string;
  stateRegistered: string;
  vehicleType: ListingCategoryTypes;
  Liters: string;
  Cylinders: string;
  hasDamage: boolean;
  description: string;
  Mileage: number;
  Price: number;
  Fuel: string;
  TitleType: string;
  licencePlate: string;
  vinNumber: string;
  sellerDisclosure: string;
  Engine: string;
  listingLiveStartDate?: Date;
  uploadImages: {
    primaryStatus: boolean;
    images: string;
  }[];

  uploadVideos?: ISellerListingUploadVideo[];
  uploadFiles: any;
  hasPendingDeal?: boolean;
  createdAt: Date;
  listingLocation?: LocationInterface;
  listingAnalytics: {
    listingViews: number;
    favoriteCount: number;
    offerCount: number;
    testDriveCount: number;
  };
  testDriveLocation?: LocationInterface;
  documentsToSign: any;
  Zip: string;
  dealPreferences: {
    isChanged: boolean;
    verifications: {
      fullVerification: boolean;
      verifiedFunds: boolean;
    };

    paymentMethod: {
      privateAutoPay: boolean;
      cash: boolean;
      crypto: {
        btc: boolean;
      };
    };
  };

  availableTimings: AvailableTimings;
  ownershipInfo: {
    vehicleHaveLien?: boolean;
    carTitle?: boolean;
    bankName: string;
    phoneNumber: string;
    loanAccountNumber: string;
    estimatedLoanAmount: string;
    ownershipType: OwnershipTypes;
    titlePossession: TitlePossessions;
    coSeller: {
      onLoan: boolean;
      firstName: string;
      lastName: string;
      phoneNumber: string;
    };
  };

  vehicleDescription: string;
  payment: { date: string; id: string };
  soldAt?: string;

  payLater?: {
    enabled: boolean;
    amount: number;
    discount: number;
    customer: string;
  };
  mpg?: string;

  titleAttachment: SellerListingTitleAttachments;
  displayType?: SellerListingDisplayTypes;

  additionalDetails: {
    motorcycle: {
      driveType: MotorcycleDriveTypes;
      category: MotorcycleCategory;
      primaryColor: string;
    };
    atv: {
      driveType: ATVDriveTypes;
      category: ATVCategories;
      starter: ATVStarters;
      weight: string;
      primaryColor: string;
    };
  };
  originalSourceInfo: { sourceSite: string };
  originalSource?: string;
}
